import * as Sentry from '@sentry/react';
import { getSentryIgnoreErrorsConfig, getSentryDenyUrlsConfig } from '@lemonadefashion/sentry-config';

// No client is allowed to send more than a certain number of events in a single session.
// This is in response to a client that once sent tens of thousands of events from their browser due to an error
// triggered from inside a scroll event handler.
const PER_CLIENT_SENTRY_EVENT_LIMIT = 50;

export function initializeSentry() {
  if (process.env.REACT_APP_SENTRY_ENABLED !== 'true') {
    console.log('Sentry blocked.');
    return;
  }
  console.log('Initializing Sentry.');
  window.__sentSentryEventCount = 0;
  const sourceCommit = process.env.REACT_APP_SENTRY_SOURCE_COMMIT;
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })
    ],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    initialScope: /^[a-f0-9]{40}$/i.test(sourceCommit || '')
      ? { tags: { source_commit: sourceCommit.toLowerCase() } }
      : undefined,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 10),
    replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE, 10),
    replaysOnErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE, 10),
    beforeSend: (event, hint) => {
      const error = hint.originalException;
      // These exceptions are coming from Microsoft servers that scrape our site when
      // a link is found in an email. They are harmless and can be ignored completely.
      if (error && error.message && error.message.match(/Object Not Found Matching Id:[0-9]+/i)) return null;
      // Return null to discard event in case we exceed the limit.
      if (window.__sentSentryEventCount >= PER_CLIENT_SENTRY_EVENT_LIMIT) return null;
      ++window.__sentSentryEventCount;
      return event;
    },
    ignoreErrors: getSentryIgnoreErrorsConfig(),
    denyUrls: getSentryDenyUrlsConfig()
  });
}
